import dynamic from 'next/dynamic';
import { ComponentType } from 'react';

const ArrowRightIconRed = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/ArrowRightIconRed')
);
const CalenderDisIcon = dynamic(
  () => import('@adecco/dis-app/src/components/atoms/Icon/Icons/CalenderDisIcon')
);
const CheckmarkIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/CheckmarkIcon')
);
const ClockDisIcon = dynamic(
  () => import('@adecco/dis-app/src/components/atoms/Icon/Icons/ClockDisIcon')
);
const CloseXIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/CloseXIcon')
);
const DocumentIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/DocumentIcon')
);
const DocumentTileDisIcon = dynamic(
  () => import('@adecco/dis-app/src/components/atoms/Icon/Icons/DocumentTileDisIcon')
);
const EditIcon = dynamic(() => import('@adecco/base-app/src/components/atoms/Icon/Icons/EditIcon'));
const EmailFilledIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/EmailFilledIcon')
);
const EmailIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/EmailIcon')
);
const EmailDisIcon = dynamic(
  () => import('@adecco/dis-app/src/components/atoms/Icon/Icons/EmailDisIcon')
);
const FlagDeIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/FlagDeIcon')
);
const FlagEnIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/FlagEnIcon')
);
const FlagPlIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/FlagPlIcon')
);
const HeadsetIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/HeadsetIcon')
);
const HeartIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/HeartIcon')
);
const HeartLineIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/HeartLineIcon')
);
const Icon404 = dynamic(() => import('@adecco/base-app/src/components/atoms/Icon/Icons/Icon404'));
const Icon410 = dynamic(() => import('@adecco/base-app/src/components/atoms/Icon/Icons/Icon410'));
const Icon500 = dynamic(() => import('@adecco/base-app/src/components/atoms/Icon/Icons/Icon500'));
const InformationIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/InformationIcon')
);
const InformationIconFilled = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/InformationIconFilled')
);
const LocationDisIcon = dynamic(
  () => import('@adecco/dis-app/src/components/atoms/Icon/Icons/LocationDisIcon')
);
const LogoFacebookIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/LogoFacebook')
);
const LogoInstagram = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/LogoInstagram')
);
const LogoKununuIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/LogoKununuIcon')
);
const LogoLinkedInIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/LogoLinkedInIcon')
);
const LogoMapsIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/LogoMapsIcon')
);
const LogoXingIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/LogoXingIcon')
);
const NoCVIcon = dynamic(() => import('@adecco/base-app/src/components/atoms/Icon/Icons/NoCVIcon'));
const PhoneFilledIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/PhoneFilledIcon')
);
const PinFilledIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/PinFilledIcon')
);
const PinIcon = dynamic(() => import('@adecco/base-app/src/components/atoms/Icon/Icons/PinIcon'));
const PlacementTypeDisIcon = dynamic(
  () => import('@adecco/dis-app/src/components/atoms/Icon/Icons/PlacementTypeDisIcon')
);
const PlusIcon = dynamic(() => import('@adecco/base-app/src/components/atoms/Icon/Icons/PlusIcon'));
const SalaryDisIcon = dynamic(
  () => import('@adecco/dis-app/src/components/atoms/Icon/Icons/SalaryDisIcon')
);
const SearchDisIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/SearchIcon')
);
const SuitCaseDisIcon = dynamic(
  () => import('@adecco/dis-app/src/components/atoms/Icon/Icons/SuitCaseDisIcon')
);
const ThxBriefCaseDisIcon = dynamic(
  () => import('@adecco/dis-app/src/components/atoms/Icon/Icons/ThxBriefCaseDisIcon')
);
const ThxContactDisIcon = dynamic(
  () => import('@adecco/dis-app/src/components/atoms/Icon/Icons/ThxContactDisIcon')
);
const ThxHeartDisIcon = dynamic(
  () => import('@adecco/dis-app/src/components/atoms/Icon/Icons/ThxHeartDisIcon')
);
const ProfileDisIcon = dynamic(
  () => import('@adecco/dis-app/src/components/atoms/Icon/Icons/ProfileDisIcon')
);
const HelpTextInfoIcon = dynamic(
  () => import('@adecco/base-app/src/components/atoms/Icon/Icons/InformationIconFilled')
);

export type IconMapType = {
  'help-text-info': ComponentType<{}>;
  'arrow-right-red': ComponentType<{}>;
  calender: ComponentType<{}>;
  checkmark: ComponentType<{}>;
  clock: ComponentType<{}>;
  'close-x': ComponentType<{}>;
  document: ComponentType<{}>;
  'document-tile': ComponentType<{}>;
  edit: ComponentType<{}>;
  email: ComponentType<{}>;
  thx_email_confirmation: ComponentType<{}>;
  'email-filled': ComponentType<{}>;
  'flag-de': ComponentType<{}>;
  'flag-en': ComponentType<{}>;
  'flag-pl': ComponentType<{}>;
  headset: ComponentType<{}>;
  'phone-filled': ComponentType<{}>;
  heart: ComponentType<{}>;
  'heart-line': ComponentType<{}>;
  information: ComponentType<{}>;
  'information-filled': ComponentType<{}>;
  location: ComponentType<{}>;
  logo_facebook: ComponentType<{}>;
  logo_instagram: ComponentType<{}>;
  logo_kununu: ComponentType<{}>;
  logo_linkedin: ComponentType<{}>;
  logo_maps: ComponentType<{}>;
  logo_xing: ComponentType<{}>;
  'no-cv': ComponentType<{}>;
  pin: ComponentType<{}>;
  'pin-filled': ComponentType<{}>;
  'placement-type': ComponentType<{}>;
  plus: ComponentType<{}>;
  thx_profile: ComponentType<{}>;
  salary: ComponentType<{}>;
  search: ComponentType<{}>;
  suitcase: ComponentType<{}>;
  thx_briefcase: ComponentType<{}>;
  thx_contact: ComponentType<{}>;
  thx_heart: ComponentType<{}>;
  '404': ComponentType<{}>;
  '410': ComponentType<{}>;
  '500': ComponentType<{}>;
  'job-location': ComponentType<{}>;
};

export const IconMap: IconMapType = {
  'job-location': LocationDisIcon,
  'help-text-info': HelpTextInfoIcon,
  'arrow-right-red': ArrowRightIconRed,
  calender: CalenderDisIcon,
  checkmark: CheckmarkIcon,
  clock: ClockDisIcon,
  'close-x': CloseXIcon,
  document: DocumentIcon,
  'document-tile': DocumentTileDisIcon,
  edit: EditIcon,
  email: EmailIcon,
  thx_email_confirmation: EmailDisIcon,
  'email-filled': EmailFilledIcon,
  'flag-de': FlagDeIcon,
  'flag-en': FlagEnIcon,
  'flag-pl': FlagPlIcon,
  headset: HeadsetIcon,
  'phone-filled': PhoneFilledIcon,
  heart: HeartIcon,
  'heart-line': HeartLineIcon,
  information: InformationIcon,
  'information-filled': InformationIconFilled,
  location: LocationDisIcon,
  logo_facebook: LogoFacebookIcon,
  logo_instagram: LogoInstagram,
  logo_kununu: LogoKununuIcon,
  logo_linkedin: LogoLinkedInIcon,
  logo_maps: LogoMapsIcon,
  logo_xing: LogoXingIcon,
  'no-cv': NoCVIcon,
  pin: PinIcon,
  'pin-filled': PinFilledIcon,
  'placement-type': PlacementTypeDisIcon,
  plus: PlusIcon,
  thx_profile: ProfileDisIcon,
  salary: SalaryDisIcon,
  search: SearchDisIcon,
  suitcase: SuitCaseDisIcon,
  thx_briefcase: ThxBriefCaseDisIcon,
  thx_contact: ThxContactDisIcon,
  thx_heart: ThxHeartDisIcon,
  '404': Icon404,
  '410': Icon410,
  '500': Icon500,
};

export type IconType = keyof IconMapType;
